
jQuery( $ => {
	// Check if text needs to be expandable or not.
	$( '.expandable-text' ).each(
		function() {
			$( this ).siblings( '.expandable-text__link' ).css( 'visibility', 'visible' );
			const maxHeight = parseInt( $( this ).css( 'maxHeight' ), 10 );
			let elHeight = 0;

			$( this ).children().each( function() {
				elHeight += $( this ).outerHeight( true );
			} );

			if ( elHeight > maxHeight ) {
				return;
			}

			$( this ).addClass( 'expanded' );
			$( this ).siblings( '.expandable-text__link' ).hide();
		}
	);

	$( '.expandable-text__link' ).click(
		function() {
			const text = $( this ).siblings( '.expandable-text' );

			addOrRemoveClass( $( this ) );
			addOrRemoveClass( text );
		}
	);

	// toggle hidden hero content for mobile.
	$( '.archive-mobile-toggled-btn' ).click(
		function( ) {
			$( this ).parents( '.expandable-hero' ).find( '.archive-mobile-toggled-content' ).toggleClass( 'expanded' );
			$( this ).toggleClass( 'expanded' );
		}
	);

	function addOrRemoveClass( elem ) {
		if ( elem.hasClass( 'expanded' ) ) {
			elem.removeClass( 'expanded' );
			return;
		}
		elem.addClass( 'expanded' );
	}
}
);
